"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _react = require("react"),
  _default = exports["default"] = function (a) {
    var b = (0, _react.useRef)();
    return (0, _react.useEffect)(function () {
      b.current = a;
    }, [a]), b.current;
  };